<template>
<div class="absolute">
    
</div>  
</template>

<script>


export default {
   
   data() {
    return {};
  }
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/page7/absolute.vue